export const SET_IS_ROUTE_LOADING = 'SET_IS_ROUTE_LOADING';
export const SET_THREE_D_PAGE_LOADING = 'SET_THREE_D_PAGE_LOADING';
export const TOGGLE_THREE_D_PAGE_LOADING  = 'TOGGLE_THREE_D_PAGE_LOADING';
export const SET_SCENE_LOADING_TITLE  = 'SET_SCENE_LOADING_TITLE';
export const SET_SCENE_LOADING_SUBTITLE  = 'SET_SCENE_LOADING_SUBTITLE';
export const SET_SCENE_LOADING_PROGRESS  = 'SET_SCENE_LOADING_PROGRESS';
export const INCREMENT_SCENE_LOADING_PROGRESS  = 'INCREMENT_SCENE_LOADING_PROGRESS';
export const INIT_SCENE_LOADER = 'INIT_SCENE_LOADER';